import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { get, isNull, sumBy, find, toLower } from 'lodash';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SubmissionError } from 'redux-form';

import CustomPlan from '../../assets/images/custom-plan-vector.png';
import AdvancedPlan from './AdvancedPlan';
import {
    getPricingDetails,
    savePlanSelection,
    updateBusinessEmail,
    setBusinessMailError,
    sendBuisinessVerificationMail,
    validateBuisinessVerificationMail,
    setBusinessMailVerifed,
    setBusinessMailVerifyError,
} from '../../store/signup/signupAction';
import OtpForm from '../validate/OtpForm';
import PasswordForm from '../../components/PasswordForm';
import Loader from '../../components/Loader';
import { USERNAME_CRITERIA } from "../../utilities/constants";

import './ChoosePlan.scss';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

/**
 * Choose plan component
 * @param {*} param0
 */
const ChoosePlan = ({
    getPricingDetails,
    selectedPlan,
    pricingData,
    savePlanSelection,
    domainName,
    otpVerified,
    updateBusinessEmail,
    businessMailError,
    setBusinessMailError,
    needMailServer,
    basicData,
    sendBuisinessVerificationMail,
    validateBuisinessVerificationMail,
    setBusinessMailVerifed,
    businessMailVerifyErr,
    businessMailVerified,
    setBusinessMailVerifyError,
    needDomain,
    businessMail
}) => {
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [businessEmail, setBusinessEmail] = useState(businessMail);
    const [starterPlanDetails, setStarterPlanDetails] = useState({});
    const [verificationForm, setVerificationForm] = useState(false);
    const [disableVerifyBtn, setDisableVerifyBtn] = useState(false);
    const [isMailVerifiactionNeeded, setIsMailVerifiactionNeeded] = useState(
        false
    );
    const [basicPlanData, setBasicPlanData] = useState({});

    useEffect(() => {
        updateBusinessEmail(businessEmail);
    }, [businessEmail, updateBusinessEmail]);
    useEffect(() => {
        if (!otpVerified) {
            history.push(`/registration/validate`);
        }
    }, [otpVerified, history]);

    useEffect(() => {
        setLoader(true);
        getPricingDetails().then((res) => {
            try {
                const jsonData = JSON.parse(
                    get(res, 'core.0.component_disp_json')
                );
                const starterConfig = {
                    starter: true,
                    flavor_id: get(jsonData, 'flavor_component_id'),
                    free_users: get(jsonData, 'core_content.0.resource', 10),
                    storage: get(jsonData, 'core_content.1.resource', '20 GB'),
                    price: sumBy(get(jsonData, 'core_content', []), (content) =>
                        parseFloat(content.amount)
                    ),
                };

                const starter = find(get(res, 'flavor'), [
                    'component_id',
                    starterConfig.flavor_id,
                ]);
                setStarterPlanDetails(starterConfig);
                const basicPlanDetailJson = {
                    flavor: {
                        description: get(starter, 'component_description'),
                        label: get(starter, 'component_name'),
                        value: starterConfig.flavor_id,
                        price: starterConfig.price,
                    },
                    users: 10,
                    storage: 20,
                    starter: true,
                };
                setBasicPlanData(basicPlanDetailJson);
                setLoader(false);
            } catch (error) {
                setLoader(false);
            }
        });
    }, [getPricingDetails, setStarterPlanDetails, savePlanSelection]);

    useEffect(() => {
        if (get(selectedPlan, 'flavor')) {
            //it exists . do nothing. a plan is already selected
        } else {
            //no plan currently selected
            savePlanSelection(basicPlanData);
        }
    }, [basicPlanData, savePlanSelection, selectedPlan]);

    /**
     * Default select for basic plan
     */
    const selectBasicPlan = () => {
        //find flavor index
        const starter = find(
            get(pricingData, 'flavor'),
            (elem) => elem.component_id === get(starterPlanDetails, 'flavor_id')
        );
        //end
        let basicPlanData;
        if (starter) {
            basicPlanData = {
                flavor: {
                    description: get(starter, 'component_description'),
                    label: get(starter, 'component_name'),
                    value: starterPlanDetails.flavor_id,
                    price: starterPlanDetails.price,
                    businessEmail: businessEmail,
                },
                users: 10,
                storage: 20,
                starter: true,
            };
        } else {
            basicPlanData = {
                flavor: {
                    description: get(
                        pricingData,
                        'flavor.0.component_description'
                    ),
                    label: get(pricingData, 'flavor.0.component_name'),
                    value: starterPlanDetails.flavor_id,
                    price: starterPlanDetails.price,
                    businessEmail: businessEmail,
                },
                users: 10,
                storage: 20,
            };
        }

        savePlanSelection(basicPlanData);
    };
    /**
     * Verify business mail
     */
    const verifyBusinessMail = () => {
        setDisableVerifyBtn(true);
        const apiData = {
            email: businessEmail + '@' + domainName,
            form_id: get(basicData, 'form_id'),
        };
        sendBuisinessVerificationMail(apiData);
        setVerificationForm(true);
        setBusinessMailVerifed(false);
    };
    /**
     * Verify otp function
     * @param {*} formData
     */
    const verifyOTP = (formData) => {
        return validateBuisinessVerificationMail({
            ...formData,
            formID: get(basicData, 'form_id'),
        }).then((res) => {
            if (res.status === 'failed') {
                throw new SubmissionError({
                    otp: 'Verification code entered is invalid',
                    _error: 'verification failed',
                });
            } else {
                setBusinessMailVerifed(true);
                setBusinessMailVerifyError(false);
                setTimeout(() => {
                    setVerificationForm(false);
                }, 10);

                // verified
            }
        });
    };
    /**
     * Check if OTP verification is needed or not
     * @param {*} value
     */
    const isThereNeedToVerifyMail = (value) => {
        const currentMail = value + '@' + domainName;
        const isNeeded = get(basicData, 'email', '') !== currentMail;

        if (!isNeeded) {
            //no need to verify email as its already verified

            setBusinessMailVerifed(true);
        }
        setIsMailVerifiactionNeeded(isNeeded);
        return isNeeded;
    };
    return (
        <div className="content choose-plan">
            {loader && <Loader />}
            <div className="content-block-right">
                <div className="sec-header-block">
                    <h1>Choose a Plan</h1>
                    <p>
                        Choose a plan and set a login for the InfinCE
                        Administrator
                    </p>
                </div>

                <div className="inf-email">
                    <div className="form-group input-btn-group">
                        <input
                            type="text"
                            className={`form-control ${businessMailError || businessMailVerifyErr
                                ? 'inf-error'
                                : ''
                                }`}
                            placeholder="InfinCE Administrator Username"
                            value={businessEmail}
                            onChange={(e) => {
                                setBusinessEmail(toLower(e.target.value).trim());
                                setBusinessMailError(false);
                                setDisableVerifyBtn(false);
                                isThereNeedToVerifyMail(
                                    toLower(e.target.value)
                                );
                            }}
                        />
                        {businessMailError && <span className="input-error">{USERNAME_CRITERIA}</span>}
                        {!needDomain &&
                            !needMailServer &&
                            isMailVerifiactionNeeded && (
                                <button
                                    className={`btn-tertiary ${!businessEmail ||
                                        (disableVerifyBtn && 'off')
                                        }`}
                                    disabled={
                                        !businessEmail || disableVerifyBtn
                                    }
                                    onClick={verifyBusinessMail}
                                >
                                    Verify
                                </button>
                            )}

                        <span className="biz-email">@ {domainName}</span>
                    </div>
                </div>

                {verificationForm && (
                    <OtpForm
                        verifyOTP={verifyOTP}
                        otpVerified={businessMailVerified}
                        otpText="Submit"
                    />
                )}
                {businessMailVerified && isMailVerifiactionNeeded && disableVerifyBtn && (
                    <span className="verify-msg">
                        Verification code has been verified successfully
                    </span>
                )}
                {!needDomain && needMailServer && <PasswordForm />}

                <div className="inf-plans-wrapper">
                    <div
                        className={`inf-plan ${get(selectedPlan, 'flavor.value') ===
                            get(pricingData, 'flavor.0.component_id') ||
                            isNull(get(selectedPlan, 'flavor.value', null))
                            ? 'plan-selected'
                            : ''
                            }`}
                    >
                        <div className="plan-head">
                            <h3>Starter</h3>
                            <p>
                                Up to{' '}
                                {get(starterPlanDetails, 'free_users', '10')}{' '}
                                users
                            </p>
                            <p className="plan-price">
                                $
                                <strong>
                                    {get(starterPlanDetails, 'price', '50')}
                                </strong>
                                /Month
                            </p>
                        </div>

                        <ul>
                            <li>Basic (2 Core, 4GB RAM)</li>
                            <li>20 GB Storage</li>
                            <li>InfinCE Workplace</li>
                        </ul>

                        <div>
                            <button
                                type="button"
                                className="btn-plan"
                                onClick={selectBasicPlan}
                            >
                                Select
                            </button>
                        </div>
                    </div>

                    <div
                        className={`inf-plan ${get(selectedPlan, 'flavor.value') ===
                            get(pricingData, 'flavor.0.component_id') ||
                            isNull(get(selectedPlan, 'flavor.value', null))
                            ? ''
                            : 'plan-selected'
                            }`}
                    >
                        <div className="plan-head">
                            <h3>Advanced</h3>
                            <p>Beyond 10 users</p>
                            <p className="plan-price">
                                {get(selectedPlan, 'monthlyPrice', 0.0) >=
                                    1 && (
                                        <>
                                            $
                                            <strong>
                                                {get(
                                                    selectedPlan,
                                                    'monthlyPrice',
                                                    0.0
                                                )}
                                            </strong>
                                            /Month
                                        </>
                                    )}
                            </p>
                        </div>

                        {get(selectedPlan, 'flavor.value') ===
                            get(pricingData, 'flavor.0.component_id') ||
                            isNull(get(selectedPlan, 'flavor.value', null)) ? (
                            <>
                                <ul>
                                    <li>.</li>
                                    <li>.</li>
                                    <li>.</li>
                                    <li>.</li>
                                </ul>
                                <div className="plan-customize">
                                    <img src={CustomPlan} alt="" />
                                    <p>
                                        Customize your plan according to your
                                        business need
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <ul>
                                    <li>
                                        {get(selectedPlan, 'flavor.label', '')}{' '}
                                        (
                                        {get(
                                            selectedPlan,
                                            'flavor.description',
                                            ''
                                        )}
                                        )
                                    </li>
                                    <li>
                                        {get(selectedPlan, 'storage', '')} GB
                                        Storage
                                    </li>
                                    <li>InfinCE Workplace</li>
                                </ul>
                            </>
                        )}

                        <div>
                            <button
                                type="button"
                                className="btn-plan"
                                onClick={() => setViewModal(true)}
                            >
                                {get(selectedPlan, 'flavor.value') ===
                                    get(pricingData, 'flavor.0.component_id') ||
                                    isNull(get(selectedPlan, 'flavor.value', null))
                                    ? 'Choose plan'
                                    : 'Change'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={viewModal}
                onRequestClose={() => setViewModal(false)}
                style={customStyles}
                contentLabel="Example Modal"
                className="advanced-plan-wrapper"
            >
                <div className="container">
                    <AdvancedPlan
                        setViewModal={setViewModal}
                        historyData={selectedPlan}
                        pricingData={pricingData}
                    />
                </div>
            </Modal>
        </div>
    );
};

const mapDispatchToProps = {
    getPricingDetails,
    savePlanSelection,
    updateBusinessEmail,
    setBusinessMailError,
    validateBuisinessVerificationMail,
    sendBuisinessVerificationMail,
    setBusinessMailVerifed,
    setBusinessMailVerifyError,
};
const mapStateToProps = (store, props) => ({
    otpVerified: get(store, 'signupReducer.otpVerified', false),
    pricingData: get(store, 'signupReducer.pricingData', {}),
    selectedPlan: get(store, 'signupReducer.planDetails', {}),
    domainName: get(store, 'signupReducer.needDomain')
        ? get(store, 'signupReducer.getDomain.domainDetails.domain', '')
        : get(store, 'signupReducer.domainDetails.businessDomain', ''),
    businessMailError: get(store, 'signupReducer.businessMailError'),
    needMailServer: get(store, 'signupReducer.needMailServer', true),
    needDomain: get(store, 'signupReducer.needDomain', true),
    basicData: get(store, 'signupReducer.basicData', {}),
    businessMailVerified: get(
        store,
        'signupReducer.businessMailVerified',
        false
    ),
    businessMailVerifyErr: get(store, 'signupReducer.businessMailVerifyErr'),
    businessMail: get(store, 'signupReducer.businessMail', ''),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChoosePlan);
